import { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";

export default function useScrollPositionLimit({ limitOn, limitOff, isMobileNavOpen, hasRegistrationNav }) {
	const router = useRouter();
	const scrollPosition = useRef(0);

	const slimNavTimer = useRef();
	const [isSlimNav, setIsSlimNav] = useState(false);

	useEffect(() => {
		if (slimNavTimer.current) {
			clearTimeout(slimNavTimer.current);
			slimNavTimer.current = false;
		}
	}, [router]);

	useEffect(() => {
		const updatePosition = () => {
			if (isMobileNavOpen) return;

			if (!hasRegistrationNav && window.scrollY > limitOn && !isSlimNav) {
				scrollPosition.current = window.scrollY;

				if (!slimNavTimer.current) {
					slimNavTimer.current = setTimeout(() => {
						setIsSlimNav(true);
						slimNavTimer.current = false;
					}, 1000);
				}
			} else if (window.scrollY < limitOff) {
				scrollPosition.current = window.scrollY;
				if (slimNavTimer.current) {
					clearTimeout(slimNavTimer.current);
					slimNavTimer.current = false;
				}
				setTimeout(() => {
					setIsSlimNav(false);
				}, 100);
			}
		};
		window.addEventListener("scroll", updatePosition);
		updatePosition();
		return () => window.removeEventListener("scroll", updatePosition);
	}, [scrollPosition.current, isMobileNavOpen]);

	return isSlimNav;
}
